"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var ParserJSON_1 = __importDefault(require("./ParserJSON"));
var Banks_1 = __importDefault(require("./Banks"));
var TransformMiddlewares_1 = __importDefault(require("./TransformMiddlewares"));
var TreeAllocation_1 = __importDefault(require("./TreeAllocation"));
var Parser = function (props) {
    var data;
    try {
        data = ParserJSON_1.default.genComponentJSON(props);
    }
    catch (err) {
        data = {
            id: 'error_' + Math.random(),
            from: 'Text',
            props: {
                text: 'Error: ' + err.message,
            }
        };
    }
    var Component;
    if (!!Banks_1.default.reactFrom[data.from])
        Component = Banks_1.default.reactFrom[data.from].reactComponent;
    else if (!!Banks_1.default.banks[data.from]) {
        Component = function (p) {
            return (react_1.default.createElement(Parser, __assign({}, p)));
        };
    }
    var renderChildren = function () {
        if (!data.tree)
            return null;
        if (!data.banks)
            return null;
        if (!data.tree.children)
            return null;
        return (react_1.default.createElement(react_1.default.Fragment, null, data.tree.children.map(function (val, i) {
            var id = val.id;
            var childData = !!data.banks && !!data.banks[id] ? data.banks[id] : undefined;
            if (!childData)
                return null;
            return (react_1.default.createElement(Parser, __assign({ key: 'render-child-' + id + '-' + i }, childData, { banks: data.banks, tree: {
                    id: childData.id,
                    children: val.children,
                } })));
        })));
    };
    return (react_1.default.createElement(Component, __assign({}, data.props, { onHoverStyle: data.onHoverStyle, onResponsiveLayout: data.onResponsiveLayout, onResponsiveStyle: data.onResponsiveStyle, style: data.style, hasWrapper: true }), renderChildren()));
};
Parser.Banks = Banks_1.default;
Parser.TransformMiddlewares = TransformMiddlewares_1.default;
Parser.TreeAllocation = TreeAllocation_1.default;
exports.default = Parser;
//# sourceMappingURL=ParserReactComponent.js.map